import "./DaPasswordSaved.css";
import Button from "@mui/material/Button";
import DaPageWrapper from "../DaPageWrapper/DaPageWrapper";
import { Translate } from "../../helpers/TranslatedComponent";
import { T_KEYS } from "../../locales/translationKeys";
import { translateStatic } from "../../hooks/useT/useT";

const DaPasswordSaved = () => {
  return (
    <DaPageWrapper
      wrapperClass={"da-passwordsaved-card da-page-wrapper"}
      iconType="lock"
      title={<Translate tKey={T_KEYS.DA.SAVED.TITLE} />}
      subtitle={<Translate tKey={T_KEYS.DA.SAVED.DESCRIPTION} />}
    >
      <Button variant="contained" fullWidth className="da-button da-passwordsaved-button">
        {translateStatic(T_KEYS.DA.BUTTON.SIGNIN)}
      </Button>
    </DaPageWrapper>
  );
};

export { DaPasswordSaved };
